function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

function SvgLogoUcloud(props) {
  const light = props.light || '#999';
  const dark = props.dark || '#000';
  return React.createElement("svg", _extends({
    height: "1em",
    viewBox: "0 0 16 16",
    width: "1em",
    xmlns: "http://www.w3.org/2000/svg",
    "uc-svg": "uc-social"
  }, props), React.createElement("path", {
    d: "M12.43 2.757l.024 6.74a3.39 3.39 0 01-.845 2.209C10.852 12.573 9.681 13 8.128 13c-4.024 0-4.311-2.87-4.322-3.56V5.603l.97-.023-.02-.944.971-.02-.01-.902.774-.033.023 5.843c0 1.375.876 1.666 1.617 1.666 1.013 0 1.618-.611 1.618-1.633V2.78zM4.454 4.653l.022.663h-.647l-.022-.64zm.95-.967l.023.663H4.78l-.025-.64zm-.992.038l.022.583H3.87l-.026-.557zm-.955.055l.026.476h-.46L3 3.802zm2.909-1.015l.022.637-.67.026v-.64zm-1.003.038l.022.583h-.566l-.022-.557zm-1.003.055l.022.476h-.459L3.9 2.88zm-.948.046l.023.381H3.07L3.05 2.93zM5.307 2l.026.476h-.46l-.022-.453zm-.997.049l.023.355-.385.023v-.356z",
    fill: "#3860f4",
    fillRule: "evenodd"
  }));
}

SvgLogoUcloud.clsName = 'icon-uc-social__logo-ucloud';
SvgLogoUcloud.remarkName = 'unknown';
export default SvgLogoUcloud;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ucloud-icons/dist/uc-social/svgr/LogoUcloud.js
// module id = 2262
// module chunks = 17 18